const webase = {
    model: {
        auth_token: null,
        user_id: null,
        currentUser: {
            id: null,
            name: '',
            image: '',
            referral_code: ''
        },
        styleGuide: null,
        fonts: [],
    },
    utils: {}
}

export default webase